import { Button, Drawer, Flex, Image, Page, Typography } from "@payping/web-components";
import { Close } from "@payping/icons";
import { closeId } from "@/assets/googleTrackIds";
import { SubLayout } from "@/components/SubLayout";
import { useAppTranslation } from "@/utils";
import { useNavigate } from "react-router-dom";
import { DashboardRoutes } from "@/router";
import { URLS } from "@payping/utilities-shared/consts";

const BankFormGuide = () => {
  const { t } = useAppTranslation();
  const navigate = useNavigate();

  return (
    <Drawer
      title={<Typography.Text>{t("digitalAccount.bankFormGuid.title")}</Typography.Text>}
      open={true}
      closeIcon={false}
      placement={"bottom"}
      height={"100%"}
      extra={
        <Button
          type={"text"}
          icon={<Close width={14} height={14} />}
          onClick={() => {
            navigate(DashboardRoutes.digitalAccount.saman.newAccount.offline?.url);
          }}
          data-google-track={closeId}
        />
      }
    >
      <Page className="background--white">
        <SubLayout>
          <div className="tw:flex! tw:justify-center!">
            <Flex vertical gap={"large"} className={"tw:max-w-full"}>
              <Typography.Title level={4} className="tw:flex! tw:justify-center!">
                {t("digitalAccount.bankFormGuid.formGuidDesc")}
              </Typography.Title>
              <Image
                src={`${URLS.STORAGE_URL}/digitalAccount/Table1.png`}
                preview={true}
                className={"tw:w-max-[866px] tw:h-max-[255px]"}
              />
              <Image
                src={`${URLS.STORAGE_URL}/digitalAccount/Table3.png`}
                preview={true}
                className={"tw:w-max-[866px] tw:h-max-[198px]"}
              />
              <Image
                src={`${URLS.STORAGE_URL}/digitalAccount/Table5.png`}
                preview={true}
                className={"tw:w-max-[866px] tw:h-max-[150px]"}
              />
            </Flex>
          </div>
        </SubLayout>
      </Page>
    </Drawer>
  );
};

export default BankFormGuide;
